import { LoaderCircle } from "lucide-react";

export default function Loader({ message = "در حال بارگذاری…" }) {
  return (
    <div className="state">
      <LoaderCircle className="spinner" size={30} strokeWidth={2} aria-hidden="true" />
      <p>{message}</p>
    </div>
  );
}
